import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const companyCostListLocaleModule: LocaleModule = {
  name: "companyCostList",
  messages: { en: en, it: it },
};
